import React from 'react'
import {useLocation} from 'react-router-dom'
import {useMediaQuery} from '@mui/material'
import AppbarAtom from '../../@atoms/to_layout/appbar/appbar.atom'
import BrandGetComponent from '../brand_get/brand_get.component'
import ContainerAtom from '../../@atoms/to_layout/container/container.atom'
import SvgIconAtom from '../../@atoms/to_content/svg_icon/svg_icon.atom'

const AppHeaderComponent: React.FC = function () {
  const location = useLocation()
  const isAppHeaderAllowed = ['/demostyled', '/login', '/my-orders'].some(
    p => p === location.pathname,
  )
  const matches = useMediaQuery('(max-width:480px)')
  const isDemoStyled = location.pathname === '/demostyled'

  if (!isAppHeaderAllowed || matches) return null

  return (
    <AppbarAtom>
      <ContainerAtom ap_type="app_header">
        {isDemoStyled ? (
          <SvgIconAtom ap_type="brand" ap_color="white" width="100" />
        ) : (
          <BrandGetComponent ap_position="app_bar" />
        )}
      </ContainerAtom>
    </AppbarAtom>
  )
}

export default AppHeaderComponent
